<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">牵线服务</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>申请人：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em" @change="updateObj">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>联系进度：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="resumeState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in resumeStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号类型：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>隐藏用户：</label>
          <el-select v-model="hideState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in hideStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="申请时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeArray" :searchType="searchType" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="sendSysMsg()">给申请人发送通知</el-button>
          <el-button type="success" @click="sendSysMsg(1)">给联系对象发送系统通知</el-button>
          <el-button type="warning" @click="update(-1, 4)">跟进中</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
        >
          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="申请时间" v-if="checkColList.indexOf('申请时间') > -1"/>

          <el-table-column label="申请人" v-if="checkColList.indexOf('申请人') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid"/>
              <p>身份证：{{scope.row.identityAuth.identityState==0?'未认证未提交':scope.row.identityAuth.identityState==1?'申请认证':scope.row.identityAuth.identityState==2?'已认证':scope.row.identityAuth.identityState==3?'认证不通过':scope.row.identityAuth.identityState==4?'正面认证不通过':scope.row.identityAuth.identityState==5?'反面不通过':''}}</p>
              <p>学历：<span v-if="scope.row.authEdu">{{scope.row.authEdu.eduState==0?'已保存':scope.row.authEdu.eduState==1?'待认证':scope.row.authEdu.eduState==2?'已认证':scope.row.authEdu.eduState==3?'认证失败':'未申请认证'}}</span><span v-else>未申请认证</span></p>
              <p>职业：<span v-if="scope.row.authJob">{{scope.row.authJob.jobState==0?'默认客户端保存没去申请认证':scope.row.authJob.jobState==1?'待认证':scope.row.authJob.jobState==2?'已认证':scope.row.authJob.jobState==3?'认证失败':'未申请认证'}}</span><span v-else>未申请认证</span></p>
              <p>车辆：<span v-if="scope.row.authCar">{{scope.row.authCar.carState==0?'默认客户端保存没去申请认证':scope.row.authCar.carState==1?'待认证':scope.row.authCar.carState==2?'已认证':scope.row.authCar.carState==3?'认证失败':'未申请认证'}}</span><span v-else>未申请认证</span></p>
              <p>房产：<span v-if="scope.row.authHouse">{{scope.row.authHouse.houseState==0?'默认客户端保存没去申请认证':scope.row.authHouse.houseState==1?'待认证':scope.row.authHouse.houseState==2?'已认证':scope.row.authHouse.houseState==3?'认证失败':'未申请认证'}}</span><span v-else>未申请认证</span></p>
            </template>
          </el-table-column>
          <el-table-column label="申请人二维码" v-if="checkColList.indexOf('申请人二维码') > -1" width="116">
            <template #default="scope">
              <GetPlain v-if="scope.row.wechat" :url="scope.row.wechat.img" :uid="scope.row.uid" :type="11" :subType="0"/>
            </template>
          </el-table-column>
          <el-table-column label="申请人头像" v-if="checkColList.indexOf('申请人头像') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="申请人日志" v-if="checkColList.indexOf('申请人日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>

          <el-table-column label="联系对象" v-if="checkColList.indexOf('联系对象') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row.toResumeInfo" showList="name,phone,uid"/>
              <p>最新登录时间：{{scope.row.toOnlineTime}}</p>
              <p>微信状态：
                <span v-if="!scope.row.toResumeInfo.wechat">未提交</span>
                <span v-else>{{scope.row.toResumeInfo.wechat.totalState==0?'未提交':scope.row.toResumeInfo.wechat.totalState==1?'待审核':scope.row.toResumeInfo.wechat.totalState==2?'已通过':scope.row.toResumeInfo.wechat.totalState==3?'未通过':''}}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column label="微信二维码" v-if="checkColList.indexOf('微信二维码') > -1" width="106">
            <template #default="scope">
              <GetPlain v-if="scope.row.toResumeInfo.wechat" :url="scope.row.toResumeInfo.wechat.img" :uid="scope.row.toResumeInfo.uid" :type="11" :subType="0"/>
            </template>
          </el-table-column>
          <el-table-column label="联系对象头像" v-if="checkColList.indexOf('联系对象头像') > -1" width="116">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.toResumeInfo.headImg.smallHeadImg" @click="showImg(scope.row.toResumeInfo)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="联系对象日志" v-if="checkColList.indexOf('联系对象日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.toResumeInfo.userLogList" />
            </template>
          </el-table-column>

          <el-table-column property="" label="联系进度" v-if="checkColList.indexOf('联系进度') > -1">
            <template #default="scope">
              <p>{{scope.row.state==-1?'已终止':scope.row.state==1?'待处理':scope.row.state==2?'待确认':scope.row.state==3?'已完成':scope.row.state==4?'跟进中':''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="feedback" label="服务说明" v-if="checkColList.indexOf('服务说明') > -1" />
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space direction="vertical" alignment="left">
                <el-button type="primary" size="small" v-show="scope.row.state==1||scope.row.state==2||scope.row.state==4" @click="update(scope.$index, 2)">完成服务</el-button>
                <el-button type="success" size="small" v-show="scope.row.state==3" @click="update(scope.$index, 3)">完成服务</el-button>
                <el-button type="danger" size="small" v-show="scope.row.state==1||scope.row.state==-1||scope.row.state==4" @click="update(scope.$index, -1)">终止服务</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="remark" label="服务备注" v-if="checkColList.indexOf('服务备注') > -1" class-name="cursor" />
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
  getMatcherPageList,
  updateMarriageUserExpire
} from '../../api/url'
import {getFormData, postFormData} from '@/api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import SendSystemMessageChat from "@/components/SendSystemMessage";
import ExpireUserSearchInfoDialog from "@/views/marriage/components/ExpireUserSearchInfoDialog";
import GetPlain from "@/components/resume/GetPlain";
import remarkDialog from "@/views/marriage/components/remarkDialog";
import updateMatcherStateDialog from "@/views/marriage/components/updateMatcherStateDialog";

export default {
  name: "MarriageMatcher",
  components: { DatePickerRange, SearchComponents, UserLog, GetPlain },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[1]['value'],

      //状态
      stateArray: [
        { label: "不限", value: -2 },
        { label: "待处理", value: 1 },
        { label: "待确认", value: 2 },
        { label: "已完成", value: 3 },
        { label: "跟进中", value: 4 },
        { label: "已终止", value: -1 },
      ],
      state: 1,

      // 身份认证
      overallAuthStateArray: [
        {label: "不限", value: -1},
        {label: "未提交", value: 0},
        {label: "待审核", value: 1},
        {label: "认证成功", value: 2},
        {label: "认证失败", value: 3},
      ],
      overallAuthState: 2,

      // 简历状态
      resumeStateArray: [
        {label: "不限", value: -1},
        {label: "未提交", value: 0},
        {label: "待审核", value: 1},
        {label: "已通过", value: 2},
        {label: "不通过", value: 3},
      ],
      resumeState: 1,

      // 封号类型
      forbiddenStateArray: [
        {label: '不限', value: -1},
        {label: '未封号', value: 0},
        {label: '已封号', value: 1},
      ],
      forbiddenState: -1,

      // 隐藏用户
      hideStateArray: [
        {label: "不限", value: -1},
        {label: "正常用户", value: 0},
        {label: "隐藏用户", value: 1}
      ],
      hideState: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchTypeArray : [
        { label: "申请人手机号", value: 1 },
        { label: "申请人昵称", value: 2 },
        { label: "申请人id", value: 3 },
        { label: "联系对象手机号", value: 4 },
        { label: "联系对象昵称", value: 5 },
        { label: "联系对象id", value: 6 }
      ],
      searchType : 3,
      searchValue: '',

      //刷新组
      colList: ['申请时间', '申请人', '申请人二维码', '申请人头像', '申请人日志', '联系对象', '微信二维码', '联系对象头像', '联系对象日志', '联系进度', '服务说明', '操作', '服务备注'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getBirthTime(val) {
      this.birthdayStartTime = val[0];
      this.birthdayEndTime = val[1];
      // console.log(val)
    },
    getBirthCheck(val) {
      this.isBirthChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = 1;
      this.state = 1;
      this.overallAuthState = 2;
      this.resumeState = 1;
      this.forbiddenState = -1;
      this.hideState = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['state'] = this.state;
      param['overallAuthState'] = this.overallAuthState;
      param['resumeState'] = this.resumeState;
      param['forbiddenState'] = this.forbiddenState;
      param['hideState'] = this.hideState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMatcherPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '申请人日志') {
        Dialog.open({
          title: '申请人日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //更新用户日志
      if(column.label == '联系对象日志') {
        Dialog.open({
          title: '联系对象日志',
          component: UserLogDialog,
          data: {
            id: row.toUserId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //婚恋服务购买记录
      if(column.label == '服务备注') {
        Dialog.open({
          title: '服务备注',
          component: remarkDialog,
          data: {
            remark: row.remark,
            id: row.userId,
          },
          confirm: (result) => {
            row.remark = result.remark
          }
        })
      }

    },

    //解除
    updateReState(idx, row) {
      this.$confirm('确定解除'+'【' + row.nickName + '】的婚恋服务吗？').then(()=>{
        this.pageDataList[idx]['reLoading'] = true
        let param = {}
        param['id'] = row.userId
        param['day'] = 0
        param['type'] = 0
        postFormData(updateMarriageUserExpire, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList.splice(idx, 1)
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['reLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['reLoading'] = false
        })
      })
    },

    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        component: ExpireUserSearchInfoDialog,
        data: {
          userForm: e,
          idx: -1,
          width: '600px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    //发送系统消息
    sendSysMsg(to) {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessageChat,
        data: {
          userIdArray: this.idArray,
          default: to == 1?'【红娘邀约】您好，平台有异性委托一伴红娘联系您，我们会在今天内给您发送短信通知，请查阅。\r\n红娘与您沟通期间，不会有任何推销内容。\r\n如有疑问，可咨询一伴官方客服微信号：yibankefu018':'',
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    /**
     * 完成任务
     */
    update(idx, state) {
      let idArr = []
      let feedback = ''
      if(idx == -1) {
        if(this.idArray.length == 0) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: '请至少选择一条记录进行操作',
            type: 'warning'
          })
          return false
        }
        idArr = this.idArray
        feedback = '红娘老师已查看你的牵线申请，将会在一周内进行跟进。'
      }else {
        idArr.push(this.pageDataList[idx]['id'])
        this.pageDataList[idx]['feedback']
      }
      Dialog.open({
        title: state==-1?'终止服务':state==4?'跟进说明':'完成服务',
        component: updateMatcherStateDialog,
        data: {
          idArr: idArr,
          state: state,
          feedback: feedback,
        },
        confirm: (result)=>{
          // this.pageDataList.splice(idx, 1);
          this.getPage()
        }
      })
    },

  },
  created() {
  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
